import React, { Component } from "react";

class KoShoppingPolicy extends Component {
  render() {
    return (
      <div className="shipping-policy-page">
        <div className="shipping-policy-container" style={styles.container}>
          <p className="shipping-policy-title" style={styles.title}>배송정책</p>

          <p className="shipping-policy-subtitle" style={styles.subTitle(64)}>배송조회</p>
          <p className="shipping-policy-description" style={styles.description(10)}>
            제품 발송 시 운송장번호와 배송업체명 등의 정보가 포함된 배송안내
            이메일이 발송됩니다. 또한 글러브웍스 웹사이트에서 고객계정에
            로그인하시면 주문상태를 확인하실 수 있습니다.
          </p>

          <p className="shipping-policy-subtitle" style={styles.subTitle(64)}>배송방법</p>
          <p className="shipping-policy-description" style={styles.description(10)}>
            모든 제품은 DHL, FEDEX, SF EXPRESS(중국 내 배송) 등 글러브웍스와
            계약된 특송업체를 통해 배송됩니다. 글러브웍스의 생산시설과
            물류창고는 중국과 미국, 일본에 위치하고 있습니다.
            <br />
            <br />
            특송업체들의 업무정책에 따라 PO박스, 사서함, 또는 RR(Rural Route)
            주소로는 배송이 되지 않습니다. 고객은 빠르고 정확한 배송을 위해
            실제로 존재하는 주소를 제공해야만 합니다. 고객의 잘못된 정보 제공나
            특송업체의 실수로 인한 배송사고는 글러브웍스에서 책임을 지지
            않습니다.
            <br />
            <br />
          </p>

          <p className="shipping-policy-subtitle" style={styles.subTitle(64)}>배송비</p>
          <p className="shipping-policy-description" style={styles.description(10)}>
            배송비는 제품군과 배송지역에 따라 다음과 같이 책정됩니다.
            <br />
            <br />
            <b style={styles.descTitle}>
              1. 글러브(커스텀 글러브/기성 글러브/트레이너 글러브/팬케이크
              글러브/프로원 시리즈) 및 파운딩 패드
            </b>
            <br />
            {/* OUTLIER - 20240122 - 4번 내용 */}
            {/* &nbsp;&nbsp;&nbsp;&nbsp; 미국 & 캐나다	US$30.00 */}
            &nbsp;&nbsp;&nbsp;&nbsp; 미국 & 캐나다 US$45.00
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp; 중남미 US$85.00
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp; 유럽 US$50.00 - US$55.00
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp; 호주 & 뉴질랜드 US$45.00
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp; 동아시아(일본, 한국) US$35.00
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp; 중국, 타이완, 홍콩 US$15.00
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp; 동남아시아 & 남아시아 US$50.00
            <br />
            <br />
            <br />
            <b style={styles.descTitle}>2. 말렛</b>
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp; 미국 & 캐나다US$30.00
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp; 중남미 US$45.00
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp; 유럽 US$23.00
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp; 호주 & 뉴질랜드US$33.00
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp; 동아시아 (일본, 한국) US$17.00
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp; 중국, 타이완, 홍콩US$13.00
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp; 동남아시아 & 남아시아US$35.00
            <br />
            <br />
            <br />
            <b style={styles.descTitle}>3. 모자 & 페넌트</b>
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp; 미국 & 캐나다 US$25.00
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp; 중남미 US$35.00
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp; 유럽 US$25.00
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp; 호주 & 뉴질랜드US$35.00
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp; 동아시아(일본, 한국) US$8.00
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp; 중국, 타이완, 홍콩 US$10.00
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp; 동남아시아 & 남아시아 US$25.00
            <br />
            <br />
            <br />
            <b style={styles.descTitle}>4. 글러브 오일</b>
            <br />
            글러브오일은 다른 제품을 구매할 시에만 함께 구매가 가능하며 배송비는
            무료입니다. 글러브오일은 개별구매가 되지 않는 점을 양해
            부탁드립니다. 대량 구매를 원하시는 경우 이메일(
            <u
              style={styles.email}
              tabIndex="-1"
              role="button"
              onClick={() =>
                (document.location.href = "mailto:contact@gloveworks.net")
              }
            >
              contact@gloveowork.net
            </u>
            )로 문의 바랍니다.
            <br />
            <br />
          </p>

          <p className="shipping-policy-subtitle" style={styles.subTitle(64)}>배송비 할인</p>
          <p className="shipping-policy-description" style={styles.description(10)}>
            4개 이상의 커스텀 글러브 또는 기성글러브를 일시에 구매하는 경우 총
            배송비의 20%가 할인됩니다. 배송비 할인은 동일 카테고리 내에서 구매할
            시에만 적용된다는 점을 양해 부탁드립니다.
          </p>

          <p className="shipping-policy-subtitle" style={styles.subTitle(64)}>관세</p>
          <p className="shipping-policy-description" style={styles.description(10)}>
            2025년 7월 기준, 일본, 한국, 미국, 대만으로 배송되는 주문은 배송비에 관세와 세금이 포함되어 있습니다.
            <br />
            그러나 캐나다와 같은 특정 지역의 경우 수입 수수료가 포함되지 않을 수 있습니다. 이러한 경우 수령인이 배송 시 운송업체에 직접 수수료를 지불해야 합니다.
            <br />
            목적지 국가에서 부과하는 세금, 관세 및 수수료("수입 수수료")가 적용될 수 있습니다. 배송 수령인은 수입국의 수입자로 간주되며 모든 해당 수입 수수료에 대한 책임이 있습니다.
            <br />
            수입 수수료에 대한 구체적인 내용이나 통관과 관련된 문서 또는 영수증을 요청하려면 배송 확인 이메일에 명시된 운송업체에 문의하시기 바랍니다.
          </p>

          <p className="shipping-policy-subtitle" style={styles.subTitle(64)}>[환불· 반품 및 교환정책]</p>

          <p className="shipping-policy-subtitle" style={styles.subTitle(64)}>주문 취소 및 환불</p>
          <p className="shipping-policy-description" style={styles.description(10)}>
            커스텀 글러브의 경우 주문 후 48시간 이내 취소가 가능합니다. 주문 후
            48시간이 지나면 제작이 시작되며, 제작이 시작된 이후에는 주문취소 및
            환불이 불가능합니다.
          </p>

          <p className="shipping-policy-subtitle" style={styles.subTitle(64)}>반품 및 교환</p>
          <p className="shipping-policy-description" style={styles.description(10)}>
            글러브웍스 커스텀 글러브는 고객 개개인의 취향에 따라 독창적으로
            만들어진 제품입니다. 따라서 제품 제작과정에서 저희 측 잘못으로
            발생한 오류나 결함, 손상이 아닌 단순 변심이나 고객 경우 반품이나
            교환이 불가합니다. 저희 측 잘못으로 문제가 발생했을 경우 제품 수령
            후 2주 이내에{" "}
            <u
              style={styles.email}
              tabIndex="-1"
              role="button"
              onClick={() =>
                (document.location.href = "mailto:donald@gloveworks.net")
              }
            >
              donald@gloveworks.net
            </u>
            로 이메일을 보내주십시오(한국어 서비스 가능).
          </p>

          <p className="shipping-policy-subtitle" style={styles.subTitle(64)}>글러브웍스 워런티 정책</p>
          <p className="shipping-policy-description" style={styles.description(10)}>
            글러브웍스는 제품수령 후 6개월 간 워런티를 보장합니다. 제품 수령 후
            6개월 이내에 품질문제가 발생했을 경우
            <u
              style={styles.email}
              tabIndex="-1"
              role="button"
              onClick={() =>
                (document.location.href = "mailto:donald@gloveworks.net")
              }
            >
              donald@gloveworks.net
            </u>
            로 이메일을 보내주시면 저희가 문제를 해결할 수 있는 최선의 방법을
            찾아내겠습니다.
          </p>
        </div>
      </div>
    );
  }
}

const styles = {
  container: {
    width: '100%',
    maxWidth: 996,
    margin: "auto",
    marginBottom: 64,
    padding: '0 20px',
    boxSizing: 'border-box',
  },
  title: {
    fontFamily: "Roboto Condensed",
    fontSize: 24,
    lineHeight: 1.33,
    letterSpacing: 0.2,
    color: "#142935",
    fontWeight: "bold",
    textAlign: "center",
    marginTop: 50,
  },
  subTitle: (marginTop) => ({
    fontSize: 18,
    fontWeight: "bold",
    lineHeight: 1.33,
    color: "#000",
    marginTop,
  }),
  description: (marginTop) => ({
    fontSize: 14,
    marginTop,
    lineHeight: 1.57,
    color: "#142935",
  }),
  descTitle: {
    fontWeight: "bold",
  },
  email: {
    color: "#007dff",
    cursor: "pointer",
    outline: "none",
  },
};

export default KoShoppingPolicy;
